module.exports = __webpack_public_path__ + "img/67_19.9d4a83b6.png";